import React, { useState, useEffect } from 'react';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import styles from '../styles/AIAssistant.style';
import ChatLoader from './ChatLoader';
import AIAssistantLabels from './AIAssistant.labels';

const AIAssistantForm = ({
  className,
  chatSummary,
  fetchResponse,
  setChatSummaryQ,
  enableAISearch,
  isLoading,
}) => {
  const aiLabels = getLabelFromCopyOrFromTranslation('global.helpCenter', AIAssistantLabels);

  const aiAssistantHeading = renderLabel(aiLabels.lbl_ai_heading_text, 'lbl_ai_heading_text');
  const userNotation = renderLabel(aiLabels.lbl_ai_user_notation, 'lbl_ai_user_notation');
  const aiNotation = renderLabel(aiLabels.lbl_ai_notation, 'lbl_ai_notation');
  const aiAssistantHelpText = renderLabel(aiLabels.lbl_ai_help_text, 'lbl_ai_help_text');
  const notAllowed = 'not-allowed';
  const [displayButton, setDisplayButton] = useState('none');
  const [disableButton, setDisableButton] = useState(notAllowed);

  const handleSubmit = (event) => {
    event.preventDefault();
    const input = document.getElementById('prompt-input');
    const { value } = input;
    if (value) {
      setChatSummaryQ(value);
      fetchResponse({ query: value });
      input.value = '';
      setDisableButton(notAllowed);
    }
  };
  const changeEvent = (e) => {
    e.preventDefault();
    const input = document.getElementById('prompt-input');
    const { value } = input;
    if (value) {
      setDisableButton('pointer');
    } else {
      setDisableButton(notAllowed);
    }
    setDisplayButton('block');
  };
  useEffect(() => {
    if (Array.isArray(chatSummary) && chatSummary.length) {
      setDisplayButton('block');
    }
    const scrollableSection = document.getElementsByClassName('scrollable-section')[0] || {};
    scrollableSection.scrollTop = scrollableSection.scrollHeight;
  }, [chatSummary]);

  const getChatDetails = (chatList) => {
    return chatList?.map((chat) => (
      <>
        <div className={`summary ${chat.query ? 'left-section' : 'right-section'}`}>
          <div className="content">
            <p className="notation">{chat.query ? userNotation : aiNotation}</p>
            <p className="message">{chat.query ? chat.query : chat.response}</p>
          </div>
        </div>
      </>
    ));
  };

  return (
    enableAISearch && (
      <div className={className}>
        <div className="container">
          <div>
            <p className="heading"> {aiAssistantHeading} </p>
            <hr />
          </div>
          <div className="scrollable-section">
            {getChatDetails(chatSummary)}
            {isLoading && <ChatLoader />}
          </div>
          <div className="main-section">
            <form className="form-container" onSubmit={handleSubmit}>
              <input
                type="text"
                id="prompt-input"
                placeholder={aiAssistantHelpText}
                onChange={changeEvent}
              />
              <button type="submit" style={{ display: displayButton, cursor: disableButton }}>
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
    )
  );
};

export default withStyles(AIAssistantForm, styles);
export { AIAssistantForm as AIAssistantFormVanilla };
